// extracted by mini-css-extract-plugin
export var title = "section-title-module--title--PsNYS";